import React, { useState } from 'react';
import TextHelper from '@/core/helpers/TextHelper';
import { SubTableSchedules } from './SubTableSchedules';
import ReusableButton from '@/presentation/reusables/Button';
import { TableProps } from '../../interfaces/propsCourseSchedule';
import { TableBody, TableCourse, TableHeader, TableRow } from './styled';
import useCourseSchedules from '@/presentation/hooks/useRegistrationTimes';

const TableCourseDesktop = ({ courses, styles, isMobile }: TableProps) => {
  const {
    fetchSchedules,
    getSchedulesForCourse,
    isLoadingSchedules,
    needsUpdate
  } = useCourseSchedules();

  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

  const toggleRow = (courseId: string) => {
    setExpandedRows((prev) => {
      const isCurrentlyExpanded = prev[courseId];
      // marcar como: necesita actualizarse
      if (isCurrentlyExpanded) {
        needsUpdate(courseId);
      }
      return {
        ...prev,
        [courseId]: !isCurrentlyExpanded
      };
    });

    if (!expandedRows[courseId]) {
      fetchSchedules(courseId);
    }
  };

  return (
    <TableCourse data-testid="table-course-desktop" style={styles}>
      <TableHeader isMobile={isMobile}>
        <div style={{ justifyContent: 'start', minWidth: 250 }}>Curso</div>
        <div style={{ justifyContent: 'end' }}>Horas semanales</div>
        <div style={{ justifyContent: 'end' }}>Créditos</div>
        <div style={{ justifyContent: 'end' }}>Ciclo</div>
        <div style={{ justifyContent: 'center' }}>Tipo</div>
        <div style={{ justifyContent: 'end', minWidth: 135 }}> </div>
      </TableHeader>
      {courses.map((course) => (
        <TableBody
          key={course.id}
          expanded={!!expandedRows[course.id]}
          isMobile={false}
        >
          <TableRow
            className={expandedRows[course.id] ? 'expanded' : ''}
            expanded={expandedRows[course.id]}
          >
            <p style={{ justifyContent: 'start', minWidth: 250 }}>
              {course.code} - {TextHelper.capitalize(course.name, false, true)}
            </p>
            <div style={{ justifyContent: 'end' }}>{course.hours}</div>
            <div style={{ justifyContent: 'end' }}>{course.credits}</div>
            <div style={{ justifyContent: 'end' }}>{course.cicle}</div>
            <div style={{ justifyContent: 'center' }}>
              <p className="courseType">{course.type}</p>
            </div>
            <div style={{ justifyContent: 'center' }}>
              <ReusableButton
                iconPrepend={
                  expandedRows[course.id] ? 'chevron-up' : 'chevron-down'
                }
                onClick={() => toggleRow(course.id)}
                style={{
                  width: '135px',
                  height: '32px',
                  fontSize: '12px',
                  padding: '0 10px'
                }}
                outlined
              >
                {expandedRows[course.id] ? 'Ocultar horarios' : 'Ver horarios'}
              </ReusableButton>
            </div>
          </TableRow>
          {expandedRows[course.id] && (
            <SubTableSchedules
              schedulesSelected={getSchedulesForCourse(course.id)}
              isLoadingSchedules={isLoadingSchedules[course.id]}
            />
          )}
        </TableBody>
      ))}
    </TableCourse>
  );
};

export default TableCourseDesktop;
